/**
 * B-1 / C-1 — stable identity per OFD card.
 *
 * Extracted out of index.js so it can be unit-tested without mounting the
 * screen. Same defect as the touchpoints screen's cardDraftKey: the backend's
 * TRIP card id is `trip:${tripId}` with no customer in it, while its siblings
 * `pending:${cxId}:${routeId}` and `disabled:${cxId}:${routeId}` do carry one.
 * A trip spans many customers, so two customers on one trip collided on a
 * single key. Here that surfaced as:
 *   - duplicate React keys out of the customers FlatList keyExtractor;
 *   - `unassignBusy={unassignBusyKey === cardDraftKey(item)}` greying out
 *     customer B's Unassign button while customer A's request was in flight.
 *
 * The draftOfd map itself did NOT collide — a `trip:` card is is_ofd, and an
 * is_ofd card can never be toggled into that map — but the key is the same key,
 * so it is fixed once, here.
 *
 * `|` is a safe separator: card ids are `<kind>:<uuid|int>[:<routeId>]` and
 * never contain it, and it is not a lodash path character (this key is passed
 * to `_.set`).
 *
 * The legacy branches are byte-identical, so a flag-OFF / old-backend response
 * behaves exactly as today — including the list's non-customer header rows
 * (ROUTE_LIST / SUMMARY / FILTER / SPACER), which fall through to `item.key`.
 */
export const cardDraftKey = (item) => {
  if (item?.trip_card_id) {
    return `${item.trip_card_id}|${item?.user_id ?? ""}`;
  }
  if (item?.user_id != null) {
    return `${item.user_id}_${item.address_id || ""}`;
  }
  return String(item?.key ?? "");
};

export default cardDraftKey;
